<svelte:options runes={true} />

<script lang="ts">"use strict";
// The code Svelte generates is different for different kinds of input, thus the not so DRY template...
let { value = $bindable(null), type = 'text', name = null, placeholder = null, required = false, error = false, onchange = undefined, onblur = undefined, onfocus = undefined } = $props();
</script>

{#if type === "password"}
  <input
    type="password"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{:else if type === "email"}
  <input
    type="email"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{:else if type === "number"}
  <input
    type="number"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{:else if type === "date"}
  <input
    type="date"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{:else if type === "hidden"}
  <input
    type="hidden"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{:else if type === "checkbox"}
<input
  type="checkbox"
  class:error
  class:required
  id={name}
  {name}
  {required}
  onchange={onchange}
  onblur={onblur}
  onfocus={onfocus}
  bind:checked={value}
  />
{:else}
  <input
    type="text"
    class="svelte-input"
    class:error
    class:required
    id={name}
    {name}
    {placeholder}
    {required}
    onchange={onchange}
    onblur={onblur}
    onfocus={onfocus}
    bind:value
  />
{/if}

<style>
	.svelte-input {
	box-sizing: border-box;
	padding: 10px 10px 10px 12px;

	min-width: 270px;
	height: 60px;

	border-radius: 3px;

	border: none;

	font-size: 18px;
	line-height: 40px;

	text-align: center;

	background: #ffffff;
	}

	.svelte-input::placeholder {
	color: #8d5fff;
	}

	.svelte-input.error {
	color: #aa1834;
	}</style>
